<template>
  <v-app>
    <v-main>
      <card-login>
        <template v-slot:text>
          <div class="text-center">
            Você não pode acessar este recurso!
          </div>
        </template>
        <template v-slot:control>
          <div class="d-flex align-center justify-center">
            <v-btn @click="handleLogout" :loading="loading" color="error darken-1">
              <v-icon left>mdi-logout</v-icon>
              Deslogar {{ current_user_employee_name || "Minha conta" }}
            </v-btn>
          </div>
        </template>
      </card-login>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: "CannotAccess",
  components: {
    CardLogin: () => import("@/_auth/components/containers/AuthCard.vue"),
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleCloseWindow(){
      window.open("", "_self").close();
    },
    handleLogout(){
      this.$router.push({name:"Logout"})
    }
  },
};
</script>
